export default "__VITE_ASSET__d677cb30__"